import styleInject from '../../../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".popup.wcl-1vbrgc2{position:fixed;top:0;left:0;width:100%;height:100%;overflow-y:auto;background-color:rgba(0, 0, 0, 0.9);display:flex;justify-content:center;align-items:center;-webkit-user-select:none;user-select:none}.popup-close.wcl-1vbrgc2{position:absolute;right:0;top:10px}.popup-content.wcl-1vbrgc2{position:relative;margin:30px;display:inline-block;width:100%;max-width:970px}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=Popup.css.js.map
